import { faker } from '@faker-js/faker'
interface BookItem {
    id: number
    book_id: string | number
    book_pic: string
    title: string
    desc?: string
    content?: string
    tags?: string[]
    list_order?: number
    update_time?: number
    extend?: {
        section_num: number
        read_num: number
    }
}
/**
 * 分页生成简单 mock 数据，用于 van-list
 */
const mockBookList = (page = 1, pageSize = 10): BookItem[] => {
    const books: BookItem[] = []
    const startId = (page - 1) * pageSize + 1
    for (let i = 0; i < pageSize; i++) {
        const id = startId + i
        books.push({
            id,
            book_id: id,
            book_pic: faker.image.urlPicsumPhotos({ width: 200, height: 300 }), // 随机封面,
            title: faker.lorem.words({ min: 2, max: 45 }),
            list_order: Math.floor(Math.random() * 50) + 1,
            update_time: Math.floor(Date.now() / 1000) - Math.floor(Math.random() * 1000000),
        })
    }
    return books
}

/**
 * 生成书籍 Mock 数据
 * @param count 生成多少本书
 */
function generateMockBooks(count: number = 10) {
    return Array.from({ length: count }).map((_, index) => ({
        id: index + 1,
        book_id: faker.string.alphanumeric(6), // 随机 book_id
        book_pic: faker.image.urlPicsumPhotos({ width: 200, height: 300 }), // 随机封面
        title: faker.lorem.words({ min: 2, max: 5 }), // 书名
        desc: faker.lorem.sentence({ min: 5, max: 12 }), // 简介
        content: faker.lorem.paragraphs({ min: 2, max: 4 }), // 📖 正文片段
        tags: faker.helpers.arrayElements( // 📌 标签
            ['都市', '玄幻', '科幻', '言情', '悬疑', '历史', '游戏', '灵异', '轻小说'],
            { min: 2, max: 4 }
        ),
        extend: {
            section_num: faker.number.int({ min: 20, max: 300 }), // 章节数
            read_num: faker.number.int({ min: 1000, max: 100000 }), // 阅读量
        },
    }))
}

export default defineNuxtPlugin(() => {
    return {
        provide: {
            mockBookList,
            mockBooks: (count: number = 5) => ({
                mayLike: generateMockBooks(count),
            }),
        },
    }
})
